import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import APIRequest from '../../../../Services/commonAPIConsumer';
export function useAdminUserSearch() {
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const searchAdminUsers = async ({
        companyName = '',
        userName = '',
        roleId = '',
        status = '',
        currentPage = 1,
        pageSize = 25
    } = {}) => {
        setError(null);

        try {
            const url = `${process.env.REACT_APP_API}${process.env.REACT_APP_API_GetAdminUserDetails}`;
            const queryParams = new URLSearchParams({
                Lang: localStorage.getItem("language") || 'en',
                companyRef: companyName,
                userEmail: userName,
                roleId,
                status,
                currentPage,
                pageSize
            });

            const response = await APIRequest.GET("", `${url}?${queryParams.toString()}`);

            if (response === "Server maintenance") {
                navigate("/maintenance");
                return { success: false, data: null, error: "Server maintenance" };
            }

            if (response && response !== "Failed to fetch" && !response.errorMessage) {
                return { 
                    success: true, 
                    data: response,
                    error: null 
                };
            }

            return { 
                success: false, 
                data: null, 
                error: response?.errorMessage || 'Failed to fetch user data' 
            };
        } catch (error) {
            console.error('Error in searchAdminUsers:', error);
            return { 
                success: false, 
                data: null, 
                error: error.message || 'An error occurred while fetching user data' 
            };
        } 
    };

    return { searchAdminUsers };
}

export default useAdminUserSearch;
